/**
 * Global 域稳定常量与应用级基础常量。
 *
 * @canonical 5.3-domain-owned-types
 * @来源 复制自 `constants/const.ts`。
 * @删除条件 阶段二引用切到 `@dbl/core/global` 后，旧 constants 文件由人工删除。
 */

export const DATALAB_DATE_EVENT = 'datalabDateEvent';

/** 表格默认分页大小。 */
export const DEFAULT_PAGE_SIZE = 10;

/** 所有 echarts 图表的默认颜色配置。 */
export const ECHART_COLOR = [
  '#5086F3',
  '#77E097',
  '#6A7597',
  '#F8CC6A',
  '#A08FF2',
  '#5EC8F1',
  '#CF61AC',
  '#F19E55',
  '#387F7D',
  '#F17C86',
  '#8EB9FF',
] as const;

export const LOCAL_STROAGE_GAME_CODE_KEY = '__DTB_DATALAB_GAME_CODE';
export const LOCAL_STROAGE_GUILD_LEFT_MENU_SHOW =
  '__DTB_datalab_guide_left_menu_had_show-';
export const LOCAL_STROAGE_GUILD_MULTI_ANALYSIS =
  '__DTB_datalab_guide_multi-analysis_had_show-';

export const SYSTEM_NAME = 'datalab';
export const ORGANIZATION_FUN = 'Funcom';
export const DEMO_GAME_LIST = ['demo', 'pc_demo'] as const;
export const DATALAB_ADMIN = 'game_manager';
export const COMMON_BUSINESS_NAME = 'databrain';

/** Datalab 权限标识：与后端权限协议对齐。 */
export const DATALAB_EDITOR = {
  // 图表开发权限
  Chart: 'editor_chart',
  // 报表开发权限
  Dashbord: 'editor_dashboard',
  // 数据表编辑权限
  Dataset: 'editor_dataset',
  // 数据库管理
  Database: 'editor_database',
  // 公共表的数据表编辑权限 (后端没有这个权限分类, 需要前端自己做数据处理)
  CommonDataset: 'common_editor_dataset',
  // 不受Datalab权限控制 (后端没有这个权限分类, 是根据前端逻辑增加的)
  WhiteSpace: 'white_space',
  // 按钮级别权限，用于控制按钮的显示是否可以显示新增图表
  AddChartBtn: 'add_chart',
  // 按钮级别权限，用于控制按钮的显示是否可以显示新增报表
  AddDashboardBtn: 'add_dashboard',
  // 数据表编辑权限
  Edit_DataSet: 'edit_dataset',
  Edit_Common_DataSet: 'edit_common_dataset',
  // 按钮级别权限, 用于控制Model的新建按钮
  AddModelBtn: 'add_model',
  // 按钮级别权限, 用于控制Model的测试按钮
  TestModelBtn: 'test_model',
  // 按钮级别权限, 用于控制Model的发布按钮
  PublishModelBtn: 'publish_model',
} as const;

export type TDatalabEditor =
  (typeof DATALAB_EDITOR)[keyof typeof DATALAB_EDITOR];

export const DEMO_PATHS = [
  '/dashboard/game/demo',
  '/dashboard/game/pc_demo',
  '/datalab/pc_demo',
  '/datalab/demo',
] as const;

// 重命名校验规则, 汉字、数字、大小写字母、空格，全角和半角状态下的小括号、下划线、中划线、中括号
export const NAME_REGEX =
  /^[\u4E00-\u9FA5\uFF41-\uFF5A\uFF21-\uFF3A\uFF10-\uFF19a-zA-Z0-9\s()_\-[\]（）＿－【】—［］　]+$/;

// 报表名称校验规则 汉字、数字、大小写字母、空格 _ - ()
export const DASHBOARD_NAME_REGEX = /^[\u4E00-\u9FA5a-zA-Z0-9 _\-()]+$/;

// 图表探索 筛选器本地保存的key
export const CHART_EXPLORE_FILTERS = '__dbl_chart_explore_filters__';
export const CHART_EXPLORE_USER_FILTER = '__dbl_chart_explore_user_filter__';

// localstorage中是否展示过图表探索的tips 的key
export const DATALAB_CHART_EXPLORE_TIPS = '__dbl_chart_explore_tips__';

// 如果需要对数据进行拼接和分割的公共 字符串
export const DATALAB_SPLIT_STR = '@DATALAB@'; // 和后端分割字符串保持一致.
// 虚拟表名称 支持英文、数字、下划线和括号。
export const VIRTUAL_TABLE_NAME_REGEX = /^[\w()]+$/; //
// 后端返回统计值的公共字符串
export const STATISTICS_LIST = [
  'Avg',
  'Avg (≠Null)',
  'Max Value',
  'Min Value',
  'Sum',
];
// 统计值拼接和风格的公共字符串
export const STATISTICS_PREFIX = '@DATALAB@STATISTICS@';
// 图表分析页面错误码 10013: 数据源存在问题，请检查数据源。 53005: 数据集缺少用户属性，不支持用户筛选。
export const DATALAB_ANALYSIS_ERROR_CODE = [10013, 53005];
export const DATALAB_NULL = 'null';
// 休闲游戏游戏代码
export const MINI_GAME_CODE = ['iaa_mpp'];
